export const frontStyleParkingSelector = ({frontStyleParking}) => frontStyleParking